import React from 'react';

export const MoodIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7FFF" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <line x1="9" y1="9" x2="9.01" y2="9" />
    <line x1="15" y1="9" x2="15.01" y2="9" />
  </svg>
);

export const GutIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7FFF" strokeWidth="2">
    <path d="M9 2v6a3 3 0 0 0 3 3h0a3 3 0 0 1 3 3v7" />
    <circle cx="12" cy="21" r="1" />
    <path d="M9 8h0a3 3 0 0 1 3 3v4" />
  </svg>
);

export const JointIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7FFF" strokeWidth="2">
    <path d="M12 2v4" />
    <path d="M12 18v4" />
    <path d="M4.93 4.93l2.83 2.83" />
    <path d="M16.24 16.24l2.83 2.83" />
    <path d="M2 12h4" />
    <path d="M18 12h4" />
    <path d="M4.93 19.07l2.83-2.83" />
    <path d="M16.24 7.76l2.83-2.83" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const FoodIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7FFF" strokeWidth="2">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2v-2" />
    <path d="M7 2v20" />
    <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3v7" />
  </svg>
);

export const NotesIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7FFF" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);
